import clientProfileEntries from './clientProfileEntriesReducer';
import clientProfileEntryDetails from './clientProfileEntryDetailsReducer';
import changeClientProfileEntryStatus from './changeClientProfileEntryStatusReducer';

export { clientProfileEntries, clientProfileEntryDetails, changeClientProfileEntryStatus };


// WEBPACK FOOTER //
// ./src/features/client-profile/reducers/index.js